// Record-level deep links from the dashboard (?return=…, ?agreement=…).
//
// The dashboard writes its link into the URL and nothing ever clears it, so a param read on
// every mount would re-open the same record on the next visit from the sidebar, days later.
// takeDeepLink reads the named params ONCE and removes them from the URL as it does.
export function takeDeepLink(names) {
  try {
    const p = new URLSearchParams(window.location.search);
    const out = {};
    let found = false;
    names.forEach((n) => {
      const v = p.get(n);
      if (v) { out[n] = v; found = true; }
      p.delete(n);
    });
    if (found) {
      const qs = p.toString();
      window.history.replaceState(null, '', qs ? `?${qs}` : window.location.pathname);
    }
    return out;
  } catch {
    return {};
  }
}
